"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcCompanyStatement = class UcCompanyStatement extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getQueryParameters(...args) {
        return { client_id: this.oid };
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_client_statement', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_columnDefaults;
    b_7315092382398562_columns;
    async $$load_b_7315092382398562_columns() {
        return [{
                field: "transaction_date",
                name: this.$fn.pgettext("CompanyStatement", "Date"),
                type: "date",
            },
            {
                field: "transaction_type",
                name: this.$fn.pgettext("CompanyStatement", "Type"),
                width: "100px",
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            conversion: "StartCase",
                            context: "CompanyStatementType",
                            filterInput: true,
                        },
                        {
                            name: "cellclass",
                            value: (row) => ({
                                'font-weight-bold': true,
                                'bg-red-200': row.transaction_type === 'invoice',
                                'bg-green-200': row.transaction_type === 'payment',
                            }),
                        },
                    ],
                },
            },
            {
                field: "transaction_number",
                name: this.$fn.pgettext("CompanyStatement", "Number"),
                width: "120px",
                type: "command",
                formatter: {
                    name: "link",
                    href: "#",
                },
            },
            {
                field: "amount",
                name: this.$fn.pgettext("CompanyStatement", "Amount"),
                type: "number",
                formatter: "number",
            },
            {
                field: "currency",
                name: this.$fn.pgettext("CompanyStatement", "Currency"),
            },
            {
                field: "balance",
                name: this.$fn.pgettext("CompanyStatement", "Balance"),
                type: "number",
                formatter: "number",
                noFooterTotals: true,
            },
        ];
    }
    dataMembers = ['ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ds: null,
                ux: null,
                b_7315092382398562_columnDefaults: {
                    sortable: false,
                    filterable: true,
                    resizable: true,
                },
                b_7315092382398562_columns: null,
            },
        };
    }
    async act_7315092382398562_showModal_7068_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_7315092382398562_command_7067_getWhen($event) {
        return $event.data.column.id === 'transaction_number' && $event.data.data.transaction_type === 'payment';
    }
    async act_7315092382398562_showModal_7070_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_7315092382398562_command_7069_getWhen($event) {
        return $event.data.column.id === 'transaction_number' && $event.data.data.transaction_type === 'invoice';
    }
    async evh_7315092382398562_command(event, scope) {
        return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_showModal_7068 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7315092382398562_showModal_7068_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_command_7067 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_showModal_7068,
            event: "command",
            when: this.evh_7315092382398562_command_7067_getWhen,
            displayName: "showModal",
        });
        const act_7315092382398562_showModal_7070 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7315092382398562_showModal_7070_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_command_7069 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_showModal_7070,
            event: "command",
            when: this.evh_7315092382398562_command_7069_getWhen,
            displayName: "showModal",
        });
        const evh_7315092382398562_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_command_7067, evh_7315092382398562_command_7069],
        });
        return {
            act_7315092382398562_showModal_7068,
            evh_7315092382398562_command_7067,
            act_7315092382398562_showModal_7070,
            evh_7315092382398562_command_7069,
            evh_7315092382398562_command,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcCompanyStatement.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcCompanyStatement.prototype, "onOid", null);
UcCompanyStatement = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcCompanyStatement);
exports.default = UcCompanyStatement;
vue_property_decorator_1.Vue.component("UcCompanyStatement", UcCompanyStatement);
